import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { Toaster } from "@/components/ui/sonner";
import { CartProvider } from "@/context/CartContext";
import { SiteSettingsProvider } from "@/context/SiteSettingsContext";
import { TextEditProvider } from "@/context/TextEditContext";
import { AuthProvider } from "@/context/AuthContext";
import HomePage from "@/pages/HomePage";
import CheckoutPage from "@/pages/CheckoutPage";
import TrackPage from "@/pages/TrackPage";
import OrderStatusPage from "@/pages/OrderStatusPage";
import AdminPage from "@/pages/AdminPage";
import KitchenPage from "@/pages/KitchenPage";
import RewardsPage from "@/pages/RewardsPage";
import ReviewsPage from "@/pages/ReviewsPage";
import AboutPage from "@/pages/AboutPage";
import PosPage from "@/pages/PosPage";
import OpsHub from "@/pages/OpsHub";
import SeasonalTheme from "@/components/SeasonalTheme";
import SiteBackground from "@/components/SiteBackground";
import AuthCallback from "@/components/AuthCallback";
import JobsPage from "@/pages/JobsPage";
import ClockPage from "@/pages/ClockPage";
import MyHoursPage from "@/pages/MyHoursPage";
import ManagerPage from "@/pages/ManagerPage";

function ManifestSwapper() {
  const { pathname } = useLocation();
  useEffect(() => {
    const APPS = [
      ["/clock", { manifest: "/manifest-clock.json", icon: "/apple-touch-icon-clock.png", theme: "#1C1917", short: "BK Clock", title: "BK Clock — Staff Clock-In" }],
      ["/myhours", { manifest: "/manifest-hours.json", icon: "/apple-touch-icon-hours.png", theme: "#9B2226", short: "My Hours", title: "My Hours — Blossom's Kitchen" }],
      ["/manager", { manifest: "/manifest-manager.json", icon: "/apple-touch-icon-inventory.png", theme: "#1C1917", short: "BK Manager", title: "BK Manager — Blossom's Kitchen" }],
      ["/inventory", { manifest: "/manifest-manager.json", icon: "/apple-touch-icon-inventory.png", theme: "#1C1917", short: "BK Manager", title: "BK Manager — Blossom's Kitchen" }],
      ["/admin", { manifest: "/manifest-admin.json", icon: "/apple-touch-icon-admin.png", theme: "#1C1917", short: "BK Admin", title: "BK Admin — Blossom's Kitchen" }],
      ["/kitchen", { manifest: "/manifest-kds.json", icon: "/apple-touch-icon-kds.png", theme: "#1C1917", short: "BK KDS", title: "BK KDS — Kitchen Display" }],
      ["/pos", { manifest: "/manifest-pos.json", icon: "/apple-touch-icon-pos.png", theme: "#1C1917", short: "BK POS", title: "BK POS — Register" }],
      ["/ops", { manifest: "/manifest-ops.json", icon: "/apple-touch-icon-ops.png", theme: "#1C1917", short: "Blossom's Ops", title: "Blossom's Ops" }],
    ];
    const manifestLink = document.querySelector('link[rel="manifest"]');
    const appleIconLink = document.querySelector('link[rel="apple-touch-icon"]');
    const themeMeta = document.querySelector('meta[name="theme-color"]');
    const titleMeta = document.querySelector('meta[name="apple-mobile-web-app-title"]');
    const app = (APPS.find(([prefix]) => pathname.startsWith(prefix)) || [null, { manifest: "/manifest.json", icon: "/apple-touch-icon.png", theme: "#9B2226", short: "Blossom's", title: "Blossom's Kitchen — Order Now" }])[1];
    if (manifestLink) manifestLink.href = app.manifest;
    if (appleIconLink) appleIconLink.href = app.icon;
    if (themeMeta) themeMeta.content = app.theme;
    if (titleMeta) titleMeta.content = app.short;
    document.title = app.title;
  }, [pathname]);
  return null;
}

function AppRouter() {
  const location = useLocation();
  // Process the OAuth session_id (URL fragment) BEFORE any route renders.
  // Read the reactive router hash, not window.location.hash.
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/checkout" element={<CheckoutPage />} />
      <Route path="/track" element={<TrackPage />} />
      <Route path="/order/:orderNumber" element={<OrderStatusPage />} />
      <Route path="/admin" element={<AdminPage />} />
      <Route path="/kitchen" element={<KitchenPage />} />
      <Route path="/rewards" element={<RewardsPage />} />
      <Route path="/reviews" element={<ReviewsPage />} />
      <Route path="/about" element={<AboutPage />} />
      <Route path="/jobs" element={<JobsPage />} />
      <Route path="/pos" element={<PosPage />} />
      <Route path="/ops" element={<OpsHub />} />
      <Route path="/clockin" element={<ClockPage />} />
      <Route path="/myhours" element={<MyHoursPage />} />
      <Route path="/manager" element={<ManagerPage />} />
      <Route path="/inventory" element={<ManagerPage />} />
      <Route path="/clock" element={<ClockPage />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <SiteSettingsProvider>
        <TextEditProvider>
        <CartProvider>
          <AuthProvider>
          <BrowserRouter>
            <ManifestSwapper />
            <SeasonalTheme />
            <SiteBackground />
            <AppRouter />
          </BrowserRouter>
          </AuthProvider>
          <Toaster position="top-center" richColors mobileOffset={{ top: 124 }} />
        </CartProvider>
        </TextEditProvider>
      </SiteSettingsProvider>
    </div>
  );
}

export default App;
